:host{position:absolute;top:50%;left:50%}
/*# sourceMappingURL=keyboard.component-4DS2UUCA.css.map */
